import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { collection, getDocs } from "firebase/firestore";
import { auth, db } from "./firebase";
import App from "./App";
import LoginPage from "./pages/LoginPage";
import WelcomeScreen from "./pages/WelcomeScreen";
import "./index.css";

const Root = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [workspaces, setWorkspaces] = useState([]);

  // Listen for authentication state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      setLoading(false);

      if (currentUser) {
        try {
          const querySnapshot = await getDocs(collection(db, "workspaces"));
          const workspaceList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setWorkspaces(workspaceList);
        } catch (error) {
          console.error("Error fetching workspaces:", error.message);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={user ? <Navigate to="/welcome" /> : <LoginPage />}
        />
        <Route
          path="/welcome"
          element={user ? <WelcomeScreen workspaces={workspaces} /> : <Navigate to="/" />}
        />
        <Route
          path="*"
          element={user ? <App workspaces={workspaces} /> : <Navigate to="/" />}
        />
      </Routes>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
